import Button from '@mui/material/Button';
import ScheduleCancelViewModel from './viewModel';
import {
  ErrorBox,
  ErrorText,
  MessageBubble,
  LoadingProgress,
  MessageText,
  ReasonItem,
  ReasonLabel,
  ReasonList,
  ReasonMessage,
  ReasonMessageHighlight,
  ScheduleCancelContainer,
  ReasonRadio
} from './styled';

type ScheduleCancelProps = {
  id: string;
};

export default function ScheduleCancel({ id }: ScheduleCancelProps) {
  const {
    options,
    selectedReason,
    handleSelectReason,
    isLoadingCancel,
    hasCancelError,
    isReasonDisabled,
    isSendingReason,
    isReasonSent,
    hasReasonError,
    loadingMessage,
    reasonPromptMessage,
    sendingReasonMessage,
    reasonSuccessMessage,
    cancelErrorMessage,
    reasonErrorMessage,
    retry
  } = ScheduleCancelViewModel({ id });

  if (hasCancelError) {
    return (
      <ErrorBox>
        <ErrorText>{cancelErrorMessage}</ErrorText>
        <Button variant="contained" onClick={retry}>
          Tentar novamente
        </Button>
      </ErrorBox>
    );
  }

  if (isLoadingCancel) {
    return (
      <MessageBubble>
        <MessageText>{loadingMessage}</MessageText>
        <LoadingProgress />
      </MessageBubble>
    );
  }

  return (
    <ScheduleCancelContainer>
      <ReasonList role="radiogroup" aria-labelledby="schedule-cancel-reason-message">
        <ReasonMessage id="schedule-cancel-reason-message">
          {reasonPromptMessage.prefix}
          <ReasonMessageHighlight>{reasonPromptMessage.highlight}</ReasonMessageHighlight>
          {reasonPromptMessage.suffix}
        </ReasonMessage>
        {options.map(reason => (
          <ReasonItem
            key={reason}
            component="div"
            role="radio"
            aria-checked={selectedReason === reason}
            disabled={isReasonDisabled}
            onClick={() => handleSelectReason(reason)}
          >
            <ReasonRadio checked={selectedReason === reason} disabled={isReasonDisabled} tabIndex={-1} disableRipple />
            <ReasonLabel>{reason}</ReasonLabel>
          </ReasonItem>
        ))}
      </ReasonList>
      {isSendingReason && (
        <MessageBubble>
          <MessageText>{sendingReasonMessage}</MessageText>
          <LoadingProgress />
        </MessageBubble>
      )}
      {isReasonSent && (
        <MessageBubble role="status">
          <MessageText>{reasonSuccessMessage}</MessageText>
        </MessageBubble>
      )}
      {hasReasonError && (
        <MessageBubble role="alert">
          <ErrorText>{reasonErrorMessage}</ErrorText>
        </MessageBubble>
      )}
    </ScheduleCancelContainer>
  );
}
